"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getUpdatedNewEvents = exports.getUpdatedEventsPageableContent = exports.updateEventInList = exports.updateEventStatusInList = exports.getUpdatedNewEventsList = exports.fillInMissingCurrentEventStatus = exports.getNewEventsPageable = void 0;

var _reactFileDownload = _interopRequireDefault(require("react-file-download"));

var _lodash = require("lodash");

var types = _interopRequireWildcard(require("./types"));

var _types2 = require("../comment/types");

var _types3 = require("../eventUpload/types");

var _types4 = require("../eventStatus/types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getNewEventsPageable = function getNewEventsPageable(eventsPageable, eventsToAdd) {
  var updatedEventsPageable = eventsPageable;

  var _loop = function _loop(i) {
    // don't allow duplicates
    if (updatedEventsPageable.content.filter(function (e) {
      return e.id === eventsToAdd[i].id;
    }).length === 0) {
      updatedEventsPageable.content.push(eventsToAdd[i]);
    }
  };

  for (var i = 0; i < eventsToAdd.length; i += 1) {
    _loop(i);
  }

  updatedEventsPageable.content = (0, _lodash.orderBy)(updatedEventsPageable.content, ['startDate'], ['desc']);
  return updatedEventsPageable;
};

exports.getNewEventsPageable = getNewEventsPageable;

var fillInMissingCurrentEventStatus = function fillInMissingCurrentEventStatus(event) {
  if (!event.currentEventStatus && event.eventStatus && event.eventStatus.length > 0) {
    return _objectSpread(_objectSpread({}, event), {}, {
      currentEventStatus: event.eventStatus.reduce(function (eventStatus, currentEventStatus) {
        return new Date(eventStatus.createdDate).getTime() > new Date(currentEventStatus.createdDate).getTime() ? eventStatus : currentEventStatus;
      })
    });
  }

  return _objectSpread(_objectSpread({}, event), {}, {
    currentEventStatus: {
      status: {
        id: -1,
        name: 'No Status'
      }
    }
  });
};

exports.fillInMissingCurrentEventStatus = fillInMissingCurrentEventStatus;

var eventInFilter = function eventInFilter(event, filter) {
  // status filter
  if (filter.statusIds && filter.statusIds.length !== 0 && filter.statusIds.indexOf(event.currentEventStatus.status.id) < 0) {
    return false;
  } // tags filter


  if (filter.tagConditions && filter.tagConditions.length !== 0) {
    for (var i = 0; i < filter.tagConditions.length; i += 1) {
      if (filter.tagConditions[i].length !== 0) {
        var foundMatchingTag = false;

        for (var j = 0; j < event.tags.length; j += 1) {
          if (filter.tagConditions[i].indexOf(event.tags[j].id) >= 0) {
            foundMatchingTag = true;
          }
        }

        if (!foundMatchingTag) {
          return false;
        }
      }
    }
  } // search text


  if (filter.searchText && filter.searchText.length > 0) {
    var foundMatch = false;

    if (event.name.indexOf(filter.searchText) >= 0) {
      foundMatch = true;
    }

    for (var _i = 0; _i < event.comments.length; _i += 1) {
      if (event.comments[_i].comment && event.comments[_i].comment.indexOf(filter.searchText) >= 0) {
        foundMatch = true;
      }
    }

    for (var _i2 = 0; _i2 < event.eventStatus.length; _i2 += 1) {
      if (event.eventStatus[_i2].statusComment && event.eventStatus[_i2].statusComment.indexOf(filter.searchText) >= 0) {
        foundMatch = true;
      }
    }

    if (event.eventData) {
      (0, _lodash.forOwn)(event.eventData, function (value) {
        if (value.value && value.value.indexOf(filter.searchText) >= 0) {
          foundMatch = true;
        }
      });
    }

    if (!foundMatch) {
      return false;
    }
  } // dates filter


  if (filter.startDate || filter.endDate) {
    var start = filter.startDate ? new Date(filter.startDate) : new Date(0);
    var end = filter.endDate ? new Date(filter.endDate) : new Date(8640000000000000);

    if (new Date(event.startDate).getTime() >= start.getTime() && new Date(event.startDate).getTime() < end.getTime()) {
      return true;
    }
  } else {
    return true;
  }

  return false;
};

var getUpdatedNewEventsList = function getUpdatedNewEventsList(newEvents, newEvent, filter) {
  var updatedNewEvents = newEvents;

  if (eventInFilter(newEvent, filter)) {
    updatedNewEvents.push(newEvent);
  }

  updatedNewEvents = (0, _lodash.orderBy)(updatedNewEvents, ['startDate'], ['desc']);
  return updatedNewEvents;
};

exports.getUpdatedNewEventsList = getUpdatedNewEventsList;

var updateEventStatusInList = function updateEventStatusInList(currentEvents, selectedEditEventId, newStatus) {
  var updatedEvents = currentEvents; // find event in list and add the new event status

  for (var i = 0; i < updatedEvents.length; i += 1) {
    if (updatedEvents[i].id === selectedEditEventId) {
      updatedEvents[i] = _objectSpread(_objectSpread({}, updatedEvents[i]), {}, {
        currentEventStatus: newStatus,
        eventStatus: [].concat(_toConsumableArray(updatedEvents[i].eventStatus), [newStatus]),
        isUpdated: true,
        completeDate: newStatus.completeEvent ? newStatus.createdDate : updatedEvents[i].completeDate
      });
    }
  }

  return (0, _lodash.orderBy)(updatedEvents, ['startDate'], ['desc']);
};

exports.updateEventStatusInList = updateEventStatusInList;

var updateEventInList = function updateEventInList(currentEvents, updatedEvent) {
  var updatedEvents = currentEvents; // find event in list and replace with new event data

  for (var i = 0; i < updatedEvents.length; i += 1) {
    if (updatedEvents[i].id === updatedEvent.id) {
      updatedEvents[i] = _objectSpread(_objectSpread({}, updatedEvent), {}, {
        isUpdated: true
      });
    }
  }

  return (0, _lodash.orderBy)(updatedEvents, ['startDate'], ['desc']);
};

exports.updateEventInList = updateEventInList;

var getUpdatedEventsPageableContent = function getUpdatedEventsPageableContent(events, data, filter) {
  var updatedEvents = events;

  if (data.eventType === 'updated-event' || data.eventType === 'completed-event' || data.eventType === 'new-event-status') {
    if (eventInFilter(data.event, filter)) {
      updatedEvents = updateEventInList(updatedEvents, data.event);
    } else {
      updatedEvents = updatedEvents.filter(function (e) {
        return e.id !== data.event.id;
      });
    }
  } else if (data.eventType === 'new-event-comment') {// do nothing
  } else if (data.eventType === 'new-event-upload') {// do nothing
  }

  return (0, _lodash.orderBy)(updatedEvents, ['startDate'], ['desc']);
};

exports.getUpdatedEventsPageableContent = getUpdatedEventsPageableContent;

var getUpdatedNewEvents = function getUpdatedNewEvents(newEvents, data, filter) {
  var updatedNewEvents = newEvents;
  var eventInNewList = newEvents.filter(function (e) {
    return e.id === data.event.id;
  }).length > 0;

  if (data.eventType === 'created-event' || data.eventType === 'updated-event' || data.eventType === 'completed-event' || data.eventType === 'new-event-status') {
    updatedNewEvents = updatedNewEvents.filter(function (e) {
      return e.id === data.event.id;
    }).length === 0 ? getUpdatedNewEventsList(updatedNewEvents, data.event, filter) : updatedNewEvents;
  }

  if (eventInNewList) {
    updatedNewEvents = getUpdatedEventsPageableContent(updatedNewEvents, data, filter);
  }

  return (0, _lodash.orderBy)(updatedNewEvents, ['startDate'], ['desc']);
};

exports.getUpdatedNewEvents = getUpdatedNewEvents;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    isFetchingEvent: false,
    isFetchingEvents: true,
    isAddingEvent: false,
    isUpdatingEvent: false,
    eventsPageable: {
      content: []
    },
    isAddingComment: false,
    isAddingUpload: false,
    newEvents: [],
    lastUpdatedDate: null,
    isFetchingDownload: false,
    isFetchingAnalytics: false,
    pollingError: false,
    analytics: {},
    selectedEditEventId: null,
    selectedEvent: {
      comments: [],
      eventUploads: [],
      eventStatus: []
    },
    isFetchingOverdueEvents: false,
    overdueEventsPageable: {
      content: []
    },
    isFetchingEventActivity: false,
    eventActivityPageable: {
      content: []
    }
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case types.SELECTED_EVENT_ID_TO_UPDATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedEditEventId: action.eventId
      });

    case types.EVENT_SEARCH_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingEvents: true
      });

    case types.EVENT_SEARCH_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingEvents: false,
        eventsPageable: getNewEventsPageable(action.events, state.eventsPageable.content),
        lastUpdatedDate: new Date(),
        pollingError: false
      });

    case types.EVENT_SEARCH_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingEvents: false
      });

    case types.EVENT_ANALYTICS_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingAnalytics: true
      });

    case types.EVENT_ANALYTICS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingAnalytics: false,
        analytics: action.analytics
      });

    case types.EVENT_ANALYTICS_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingAnalytics: false,
        analytics: {}
      });

    case types.EVENT_UPDATE:
      var updatedAction = _objectSpread(_objectSpread({}, action), {}, {
        data: _objectSpread(_objectSpread({}, action.data), {}, {
          event: fillInMissingCurrentEventStatus(action.data.event)
        })
      });

      var content = getUpdatedEventsPageableContent(JSON.parse(JSON.stringify(state.eventsPageable.content)), updatedAction.data, updatedAction.filter);
      var newEvents = state.newEvents;

      if (content.filter(function (e) {
        return e.id === updatedAction.data.event.id;
      }).length === 0) {
        // only look to add to new list if event does not already exist in normal event list
        newEvents = getUpdatedNewEvents(JSON.parse(JSON.stringify(state.newEvents)), updatedAction.data, updatedAction.filter);
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        eventsPageable: _objectSpread(_objectSpread({}, state.eventsPageable), {}, {
          // hard clone for rerenders
          content: content
        }),
        newEvents: newEvents,
        selectedEvent: (updatedAction.data.eventType === 'updated-event' || updatedAction.data.eventType === 'completed-event') && state.selectedEvent && state.selectedEvent.id === updatedAction.data.event.id ? _objectSpread(_objectSpread({}, state.selectedEvent), updatedAction.data.event) : state.selectedEvent,
        lastUpdatedDate: new Date(),
        pollingError: false
      });

    case types.EVENT_UPDATE_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        pollingError: true
      });

    case types.RESET_NEW_EVENTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        eventsPageable: getNewEventsPageable(state.eventsPageable, state.newEvents),
        newEvents: [],
        lastUpdatedDate: new Date(),
        pollingError: false
      });

    case types.EVENT_ADD_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isAddingEvent: true
      });

    case types.EVENT_ADD_SUCCESS:
      if (state.newEvents.filter(function (e) {
        return e.id === action.newEvent.id;
      }).length === 0) {
        state.newEvents.unshift(action.newEvent);
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        isAddingEvent: false,
        newEvents: state.newEvents
      });

    case types.EVENT_ADD_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isAddingEvent: false
      });

    case types.EVENT_PATCH_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isUpdatingEvent: true
      });

    case types.EVENT_PATCH_SUCCESS:
      state.eventsPageable.content = updateEventInList(state.eventsPageable.content, action.updatedEvent); // eslint-disable-line

      return _objectSpread(_objectSpread({}, state), {}, {
        isUpdatingEvent: false,
        eventsPageable: state.eventsPageable,
        // hard clone to force render
        selectedEvent: action.updatedEvent,
        selectedEditEventId: null
      });

    case types.EVENT_PATCH_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isUpdatingEvent: false,
        selectedEditEventId: null
      });

    case types.RESET_EVENT_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        eventsPageable: {
          content: []
        },
        newEvents: []
      });

    case types.SELECTED_EVENT_CHANGED:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedEvent: action.selectedEvent
      });

    case types.EVENT_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingEvent: true,
        selectedEvent: {
          comments: [],
          eventUploads: [],
          eventStatus: []
        }
      });

    case types.EVENT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingEvent: false,
        selectedEvent: action.event
      });

    case types.EVENT_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingEvent: false
      });

    case types.EVENT_ADD_COMMENT_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isAddingComment: true
      });

    case types.EVENT_ADD_COMMENT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isAddingComment: false,
        selectedEvent: _objectSpread(_objectSpread({}, state.selectedEvent), {}, {
          comments: [].concat(_toConsumableArray(state.selectedEvent.comments), [action.newComment])
        })
      });

    case types.EVENT_ADD_COMMENT_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isAddingComment: false
      });

    case types.EVENT_ADD_UPLOAD_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isAddingUpload: true,
        isUpdatingEvent: true
      });

    case types.EVENT_ADD_UPLOAD_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isAddingUpload: false,
        isUpdatingEvent: false,
        selectedEvent: _objectSpread(_objectSpread({}, state.selectedEvent), {}, {
          eventUploads: [].concat(_toConsumableArray(state.selectedEvent.eventUploads), [action.newEventUpload])
        })
      });

    case types.EVENT_ADD_UPLOAD_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isAddingUpload: false,
        isUpdatingEvent: false
      });

    case types.EVENT_CHANGE_STATUS_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isChangingStatus: true
      });

    case types.EVENT_CHANGE_STATUS_SUCCESS:
      state.eventsPageable.content = updateEventStatusInList(state.eventsPageable.content, state.selectedEditEventId, action.newStatus); // eslint-disable-line

      return _objectSpread(_objectSpread({}, state), {}, {
        isChangingStatus: false,
        eventsPageable: state.eventsPageable,
        // hard clone to force render
        selectedEvent: _objectSpread(_objectSpread({}, state.selectedEvent), {}, {
          // need this otherwise changing status from event detail page
          // to auto complete status won't reflect completion on event detail page
          completeDate: action.newStatus.completeEvent ? new Date() : state.selectedEvent.completeDate,
          eventStatus: [].concat(_toConsumableArray(state.selectedEvent.eventStatus), [action.newStatus]),
          currentEventStatus: action.newStatus
        }),
        selectedEditEventId: null
      });

    case types.EVENT_CHANGE_STATUS_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isChangingStatus: false,
        selectedEditEventId: null
      });

    case types.EVENT_EXPORT_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingDownload: true
      });

    case types.EVENT_EXPORT_SUCCESS:
      //eslint-disable-line
      var blob = new Blob([action.download], {
        type: 'application/octet-stream'
      });
      (0, _reactFileDownload["default"])(blob, 'events_export.csv');
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingDownload: false
      });

    case types.EVENT_EXPORT_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingDownload: false
      });

    case _types2.COMMENT_EDIT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedEvent: _objectSpread(_objectSpread({}, state.selectedEvent), {}, {
          comments: state.selectedEvent.comments.map(function (c) {
            if (c.id === action.updatedComment.id) {
              return action.updatedComment;
            }

            return c;
          })
        })
      });

    case _types2.COMMENT_DELETE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedEvent: _objectSpread(_objectSpread({}, state.selectedEvent), {}, {
          comments: state.selectedEvent.comments.filter(function (c) {
            return c.id !== action.commentId;
          })
        })
      });

    case _types3.EVENT_UPLOAD_DELETE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedEvent: _objectSpread(_objectSpread({}, state.selectedEvent), {}, {
          eventUploads: state.selectedEvent.eventUploads.filter(function (eu) {
            return eu.id !== action.eventUploadId;
          })
        })
      });

    case _types4.EVENT_STATUS_EDIT_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isChangingStatus: true
      });

    case _types4.EVENT_STATUS_EDIT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isChangingStatus: false,
        selectedEvent: _objectSpread(_objectSpread({}, state.selectedEvent), {}, {
          currentEventStatus: state.selectedEvent.currentEventStatus.id === action.updatedEventStatus.id ? action.updatedEventStatus : state.selectedEvent.currentEventStatus,
          eventStatus: state.selectedEvent.eventStatus.map(function (es) {
            if (es.id === action.updatedEventStatus.id) {
              return action.updatedEventStatus;
            }

            return es;
          })
        })
      });

    case _types4.EVENT_STATUS_DELETE_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isChangingStatus: true
      });

    case _types4.EVENT_STATUS_DELETE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isChangingStatus: false,
        selectedEvent: _objectSpread(_objectSpread({}, state.selectedEvent), {}, {
          currentEventStatus: state.selectedEvent.currentEventStatus.id === action.eventStatusId ? state.selectedEvent.eventStatus.filter(function (es) {
            return es.id !== action.eventStatusId;
          }).sort(function (a, b) {
            return b.createdDate - a.createdDate;
          })[0] : state.selectedEvent.currentEventStatus,
          eventStatus: state.selectedEvent.eventStatus.filter(function (es) {
            return es.id !== action.eventStatusId;
          })
        })
      });

    case types.EVENT_SEARCH_OVERDUE_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingOverdueEvents: true
      });

    case types.EVENT_SEARCH_OVERDUE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingOverdueEvents: false,
        overdueEventsPageable: action.overdueEvents
      });

    case types.EVENT_SEARCH_OVERDUE_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingOverdueEvents: false
      });

    case types.EVENT_ACTIVITY_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingEventActivity: true
      });

    case types.EVENT_ACTIVITY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingEventActivity: false,
        eventActivityPageable: action.eventActivityPageable
      });

    case types.EVENT_ACTIVITY_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        isFetchingEventActivity: false
      });

    default:
      return state;
  }
};

exports["default"] = _default;